import { Logger, type LoggerAPI, LogLevel } from '@ad-lucy/utils';

const logger = Logger({
  tag: 'COMPONENTS',
  minLevel: LogLevel.DEBUG,
});

export const getModuleLogger = logger.getModuleLogger;

export const LoggerService = ((): { getLogger: () => LoggerAPI } => {
  return {
    getLogger: (): LoggerAPI => logger,
  };
})();
